import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";

export function sendEmails(payload) {
  return { type: actionTypes.SEND_EMAILS, payload };
}

export function sendEmailsSuccess(payload) {
  // console.log('principal emails=========', payload)
  const byId = keyBy(payload, (user) => user.userUid);
  return { type: actionTypes.SEND_EMAILS_SUCCESS, payload: { byId } };
}

// export function sendEmailsFailed(payload) {
//   console.log(payload)
//   return { type: actionTypes.SEND_EMAILS_FAILED, payload };
// }

export function clearSendEmailsState() {
  return { type: actionTypes.CLEAR_SEND_EMAIL_STATE };
}

export function saveEmailText(payload) {
  return { type: actionTypes.SAVE_EMAIL_TEXT, payload };
}

export function saveEmailTextSuccess(payload) {
  console.log("save email text....", payload);
  return { type: actionTypes.SAVE_EMAIL_TEXT_SUCCESS, payload };
}

export function updateEmailText(payload) {
  console.log("passed");
  return { type: actionTypes.UPDATE_EMAIL_TEXT, payload };
}

export function updateEmailTextSuccess(payload) {
  console.log("save email text....", payload);
  return { type: actionTypes.UPDATE_EMAIL_TEXT_SUCCESS, payload };
}

export function getEmailText(payload) {
  return { type: actionTypes.GET_WEEKLY_EMAIL_TEXT, payload };
}

export function getEmailTextSuccess(payload) {
  console.log("payload=====>", payload);
  const byId = keyBy(payload, (data) => data.weeklyemailtextUid);
  return { type: actionTypes.GET_WEEKLY_EMAIL_TEXT_SUCCESS, payload: { byId } };
}

export function sendWeeklyEmails(payload) {
  return { type: actionTypes.SEND_WEEKLY_EMAILS, payload };
}

export function sendWeeklyEmailsSuccess(payload) {
  // console.log('principal emails=========', payload)
  const byId = keyBy(payload, (user) => user.userUid);
  return { type: actionTypes.SEND_WEEKLY_EMAILS_SUCCESS, payload: { byId } };
}
export function clearWeeklyEmailsUserState() {
  return { type: actionTypes.CLEAR_USER_STATE };
}
